import { render, staticRenderFns } from "./UiChargebacks.vue?vue&type=template&id=0804385e&"
import script from "./UiChargebacks.vue?vue&type=script&lang=js&"
export * from "./UiChargebacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports